Prism.languages.http = {
  "request-line": {
    pattern: /^(?:POST|GET|PUT|DELETE|OPTIONS|PATCH|TRACE|CONNECT)\s(?:https?:\/\/|\/)\S+\sHTTP\/[0-9.]+/m,
    inside: {
      property: /^(?:POST|GET|PUT|DELETE|OPTIONS|PATCH|TRACE|CONNECT)\b/,
      "attr-name": /:\w+/
    }
  },
  "response-status": {
    pattern: /^HTTP\/1.[01] \d+.*/m,
    inside: {
      property: {
        pattern: /(^HTTP\/1.[01] )\d+.*/i,
        lookbehind: !0
      }
    }
  },
  "header-name": {
    pattern: /^[\w-]+:(?=.)/m,
    alias: "keyword"
  }
};
var httpLanguages = {
  "application/json": Prism.languages.javascript,
  "application/xml": Prism.languages.markup,
  "text/xml": Prism.languages.markup,
  "text/html": Prism.languages.markup
};

for (var contentType in httpLanguages) {
  if (httpLanguages[contentType]) {
    var options = {};
    options[contentType] = {
      pattern: new RegExp("(content-type:\\s*" + contentType + "[\\w\\W]*?)(?:\\r?\\n|\\r){2}[\\w\\W]*", "i"),
      lookbehind: !0,
      inside: {
        rest: httpLanguages[contentType]
      }
    }, Prism.languages.insertBefore("http", "header-name", options);
  }
}